import React, { Component } from 'react';
// Externals
import compose from 'recompose/compose';
import styles from './styles';
import { withStyles } from '@material-ui/core/styles';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import highchartsMore from "highcharts/highcharts-more.js";
import xRange from "highcharts/modules/xrange.js";
import { withRouter } from 'react-router-dom';
import EventsTable from '../../EventsObjective/EventsObjectiveTableLight';
//import {getDetalleDisponibilidadGlobalObjetivoDowntimeCustom} from '../../../../../services/getDetalleDisponibilidadGlobalObjetivoDowntimeC'
//import {getDetalleDisponibilidadGlobalObjetivoDowntime} from '../../../../../services/getDetalleDisponibilidadGlobalObjetivoDowntime'
//import {getDetalleDisponibilidadParcialObjetivoDowntime} from '../../../../../services/getDetalleDisponibilidadParcialObjetivoDowntime'
import {getDetalleDisponibilidadConsolidada} from '../../../../../services/getDetalleDisponibilidadConsolidada'
import {getDetalleDisponibilidadConsolidadaCustom} from '../../../../../services/getDetalleDisponibilidadConsolidadaCustom'
import PortletContent from 'components/PortletContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import moment from 'moment'
import 'moment/locale/es'  
import { Dialog } from '@material-ui/core';
import { COLORS } from '../../../../../utils/colors';
import { useTranslation, withTranslation } from 'react-i18next';
import { reportFetchError } from '../../../../../observability/rum';
moment.locale('es')

highchartsMore(Highcharts);
xRange(Highcharts);
Highcharts.setOptions({
    lang: {
        months: [
            'Enero', 'Febrero', 'Marzo', 'Abril',
            'Mayo', 'Junio', 'Julio', 'Agosto',
            'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ],
        weekdays: [
            'Domingo', 'Lunes', 'Martes', 'Miércoles',
            'Jueves', 'Viernes', 'Sábado'
        ],
        shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
    }
});
class AvailabilityConsolidated extends Component {

    constructor(props) {
        super(props);
        var periodical = false
        if (props.params.periodical == true){
            periodical = true
        }
        this.state = {
            currentObjectiveId: this.props.match.params.objetivo_id,
            prevObjectiveId: this.props.match.params.objetivo_id,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            loadError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            hoverData: null,
            lastEvent: [],
            statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,
            chartOptionsBase: this._chartOptionsBase,
            chartOptionsStackedBarConsolidated: null,
            chartOptionsStackedBarNode: null,
            isRefresh: this.props.params.isRefresh,
            date: this.props.params.date,
            dateMoment:((moment().locale('es')).format("dddd, DD/MM/YYYY, h:mm:ss a")),
            modalOpen: false,
            modalClose : true, 
            point: [],
            monitores: [],
            schedule:0,
            periodical:periodical,
        }
    }
    _chartOptionsBase = {
        chart: {
            type: 'xrange'
        },
        title: {
            text: "",
            style: {
                fontSize: '20px' 
             },
             margin: 20,
        },
        subtitle: {
            text: '',
            style: {
                color: '',
                fontWeight: '',
                fontSize: '',
            },
            
        },
        
        xAxis: {
            type: 'datetime',
            gridLineWidth: 0,
            dateTimeLabelFormats: {
                second: '%l:%M:%S%P',
                minute: '%l:%M%P',
                hour: '%H:%M',
                day: '<br/><b>%e/%b</b>',
                week: '%e. %b',
                month: '%b %y',
                year: '%Y'
            },
        },
        yAxis: {
            title: {
                text: ''
            },
            gridLineWidth: 0,
            reversed: true,
            labels: {
                useHTML:true,//set to true
                // align: 'left',
                style:{
                    // width:'200px',
                    whiteSpace:'normal'//set to normal
                },
                step: 1,
                formatter: function () {//use formatter
                    return '<div align="left" style="word-wrap: break-word;word-break: break-all;width:150px">' + this.value + '</div>';
                }
            },
        },
        series: [{
            //name: 'Project 1',
            // pointPadding: 0,
            // groupPadding: 0,
            //borderColor: 'gray',
            pointWidth: 10,
            turboThreshold: 30000,
            boostThreshold: 1,            /*animation: {
                duration: 10000,
                // Uses Math.easeOutBounce
                easing: 'easeOutBounce'
            },*/
            animation: false,
            dataLabels: {
                enabled: true
            }
        }],
       
        plotOptions: {
            series: {
                //borderRadius: 5,
                borderRadius: '0px',
                borderColor: 'transparent',
                turboThreshold: 30000,
                boostThreshold: 1,
                pointWidth: 10,
                grouping: false
            }
        },
        credits: {
            enabled: false
        },
        tooltip: {
            enabled: false,
        }
    }

    showFirstStep = () => {
        const { fromObjective } = this.props.location.state
        this.props.params.onInfo({ x: '', x2: '', y: '' }, fromObjective.Pasos[0].nombre_paso)
    }

    setHoverDataBar = (e) => {      
        const { x, x2, y, series, yCategory } = e.target 
        // The chart is not updated because `chartOptions` has not changed.
        let point = []
        point['x'] = x
        point['x2'] = x2
        point['y'] = series.chart.yAxis[0].categories[y]
        let step = series.userOptions.name
        this.props.params.onInfo(point, step)
    }

    setClickDataBar = (e) => {
        const { x, x2, y, series, yCategory } = e.point
        // The chart is not updated because `chartOptions` has not changed.
        let point = []
        point['x'] = x
        point['x2'] = x2
        point['y'] = series.chart.yAxis[0].categories[y]
        let step = series.userOptions.name
        this.setState({
            point: point,
            modalOpen: true,
            modalClose : false
        })
        //this.props.params.onInfoModal(point, step)
    }

    setCloseModal=()=>{
        this.setState({
            modalOpen : false,
            modalClose : true
        })
    }

    static getDerivedStateFromProps(props, state) {
        if (props.match.params.objetivo_id !== state.prevObjectiveId) {
            return {
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
            }
        } else if (props.params.period !== state.time) {
            return {
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isStatePeriod: props.params.isStatePeriod
            }
        } else if ((props.params.period === state.time) && (props.params.statePeriod !== state.statePeriod)) {
            return {
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isStatePeriod: props.params.isStatePeriod
            }
        } else if(props.params.isRefresh !== state.isRefresh){
            return {
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isRefresh: props.params.isRefresh,          
            }

        }else if(props.params.date !== state.date){
            return {
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                date: props.params.date,          
            }

        }
        return null;
    }


    componentDidMount() {
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {
        if((prevProps.params.isRefresh !== this.state.isRefresh) && this.state.dateMoment!==((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))){
            this.props.params.onDateMoment(((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")))
        }
        if ((prevProps.params.period !== this.state.time) ||
            (prevProps.match.params.objetivo_id !== this.props.match.params.objetivo_id) ||
            (prevProps.params.statePeriod !== this.state.statePeriod) ||
            (prevProps.params.isRefresh !== this.state.isRefresh)||
            (prevProps.params.date !== this.state.date)) {
            this.getDataFromAPI();
        }

    }
    componentWillUnmount() {

    }

    getDataFromAPI = (objectiveId) => {
        this.setState({
            isLoading: true,
            loadError: false,
        })
        this.props.params.onInfo({}, null)
        const { objetivo_id } = this.props.match.params
        const { fromObjective } = this.props.location.state
        const { period, statePeriod, schedule } = this.props.params
        const { history } = this.props;
        let sla_rendimiento_ok = parseInt(fromObjective.sla_rendimiento_ok)
        let sla_rendimiento_error = parseInt(fromObjective.sla_rendimiento_error)
        let sla_disponibilidad_ok = parseInt(fromObjective.sla_disponibilidad_ok)
        let sla_disponibilidad_error = parseInt(fromObjective.sla_disponibilidad_error)
        let fecha_inicio = null
        let fecha_termino = null
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')
        var node = 0
        if (period === 'c') {
            fecha_inicio = statePeriod.startDate.toISOString().substring(0, 10)
            // fecha_termino = statePeriod.endDate.toISOString().substring(0, 10)
            // correccion para que la fecha sea hora local
            fecha_termino = moment(statePeriod.endDate).format().substring(0, 10)
            Promise.all([
                getDetalleDisponibilidadConsolidadaCustom(user, objetivo_id, node, fecha_inicio, fecha_termino, token, schedule)])
                .then(([res1]) => {
                    if (!res1.ok && res1.status !== 401) throw new Error(`HTTP error ${res1.status}`);
                    return Promise.all([res1.json()])
                })
                .then(([res1]) => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (res1.status == 1 || res1.status == 5) {
                        localStorage.setItem('isAuthenticated', false);
                        this.setState({ dataError: true, data: null, isLoading: false });
                    } else if (!res1.Objetivo) {
                        this.setState({ dataError: true, data: null, chartOptionsStackedBarConsolidated: null, isLoading: false });
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(res1, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                fecha_inicio,
                                fecha_termino)
                            if (this.state.lastEvent && this.state.lastEvent.length > 0) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }
                        } catch (error) {
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }
                })
                .catch(error => {
                    reportFetchError('AvailabilityConsolidated', error);
                    this.setState({ loadError: true, data: null, chartOptionsStackedBarConsolidated: null, isLoading: false });
                });
        } else {
            Promise.all([
                getDetalleDisponibilidadConsolidada(user, objetivo_id, period, node, token)
            ])
                .then(([res1]) => {
                    if (!res1.ok && res1.status !== 401) throw new Error(`HTTP error ${res1.status}`);
                    return Promise.all([res1.json()])
                })
                .then(([res1, res2]) => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (res1.status == 1 || res1.status == 5) {
                        localStorage.setItem('isAuthenticated', false);
                        this.setState({ dataError: true, data: null, isLoading: false });
                    } else if (!res1.Objetivo) {
                        this.setState({ dataError: true, data: null, chartOptionsStackedBarConsolidated: null, isLoading: false });
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(res1, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                fecha_inicio,
                                fecha_termino)
                            if (this.state.lastEvent && this.state.lastEvent.length > 0) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }
                        } catch (error) {                          
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }

                })
                .catch(error => {
                    reportFetchError('AvailabilityConsolidated', error);
                    this.setState({ loadError: true, data: null, chartOptionsStackedBarConsolidated: null, isLoading: false });
                });

        }
    }

    handleRetry = () => {
        this.getDataFromAPI();
    }

    // Helper para procesar la data de la petición a la API

    processData = (externalData,
        sla_rendimiento_ok,
        sla_rendimiento_error,
        sla_disponibilidad_ok,
        sla_disponibilidad_error,
        period,
        fecha_inicio,
        fecha_termino) => {
        const {periodical} = this.state    
        const { Nodo, Objetivo_Nombre, Monitores, Global, paso_critico} = externalData.Objetivo
        const { estado } = Global[0]
        let lastEventDict = []
        let arrayChartDataStackedBar = [] 
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        if (period === 'h') {
            lastEventDict['namePeriod'] = `${t('text.range')}: ${t('period.text.last-hour')}`
        } else if (period === 'd') {
            lastEventDict['namePeriod'] = `${t('text.range')}: ${t('period.text.last-day')}`
        } else if (period === 'w') {
            lastEventDict['namePeriod'] = `${t('text.range')}: ${t('period.text.last-week')}`
        } else if (period === 'c') {
            lastEventDict['namePeriod'] = `${t('text.range')}: ${fecha_inicio} ${t('text.to2')} ${fecha_termino}`
        }
           
        let dictDataStackedBarUptime = {}
        dictDataStackedBarUptime['name'] = t('objective.status.uptime')
        dictDataStackedBarUptime['pointWidth'] = 40
        let arrayDataUptime = []

        let dictDataStackedBarDowntime = {}
        dictDataStackedBarDowntime['name'] = t('objective.status.downtime')
        dictDataStackedBarDowntime['pointWidth'] = 40
        let arrayDataDowntime = []

        let dictDataStackedBarNoMon = {}
        dictDataStackedBarNoMon['name'] = t('objective.status.no-monitoring')
        dictDataStackedBarNoMon['pointWidth'] = 40
        let arrayDataNoMon = []

        let dictDataStackedBarPartial = {}
        dictDataStackedBarPartial['name'] = t('objective.status.partial')
        dictDataStackedBarPartial['pointWidth'] = 40
        let arrayDataPartial = []

        let dictDataStackedBarEvent = {}
        dictDataStackedBarEvent['name'] = t('objective.status.maintenance')
        dictDataStackedBarEvent['pointWidth'] = 40
        let arrayDataEvent = []

        let dictDataStackedBarMarcadoAtentus = {}
        dictDataStackedBarMarcadoAtentus['name'] = t('objective.status.marked-atentus')
        dictDataStackedBarMarcadoAtentus['pointWidth'] = 40
        let arrayDataMarcadoAtentus = []

        //Diccionarios y listas para información por nodos
        let dictDataStackedBarUptimeNode = {}
        dictDataStackedBarUptimeNode['name'] = t('objective.status.uptime')
        dictDataStackedBarUptimeNode['pointWidth'] = 20
        let arrayDataUptimeNode = []

        let dictDataStackedBarDowntimeNode = {}        
        dictDataStackedBarDowntimeNode['name'] = t('objective.status.downtime')
        dictDataStackedBarDowntimeNode['pointWidth'] = 20
        let arrayDataDowntimeNode = []

        let dictDataStackedBarNoMonNode = {}
        dictDataStackedBarNoMonNode['name'] = t('objective.status.no-monitoring')
        dictDataStackedBarNoMonNode['pointWidth'] = 20
        let arrayDataNoMonNode = []

        let dictDataStackedBarPartialNode = {}
        dictDataStackedBarPartialNode['name'] = t('objective.status.partial')
        dictDataStackedBarPartialNode['pointWidth'] = 20
        let arrayDataPartialNode = []

        let dictEventClient = {}
        dictEventClient['name'] = t('objective.status.maintenance')
        dictEventClient['pointWidth'] = 20
        let arrayEventClient= []

        let dictEventMarcadoClienteNode = {}
        dictEventMarcadoClienteNode['name'] = t('objective.status.marked-atentus')
        dictEventMarcadoClienteNode['pointWidth'] = 20
        let arrayMarcadoClienteNode= []
        

        Object.keys(estado).map((key) => {
            let dictDataStackedBar = {}

            let dateJson = new Date(estado[key]['fecha_desde'].substring(0, 19))
            let year = dateJson.getFullYear()
            let month = dateJson.getMonth()
            let day = dateJson.getDate()
            let hours = dateJson.getHours()
            let minutes = dateJson.getMinutes()
            let seconds = dateJson.getSeconds()

            let dateJsonEnd = (new Date(estado[key]['fecha_hasta'].substring(0, 19)))
            let yearEnd = dateJsonEnd.getFullYear()
            let monthEnd = dateJsonEnd.getMonth()
            let dayEnd = dateJsonEnd.getDate()
            let hoursEnd = dateJsonEnd.getHours()
            let minutesEnd = dateJsonEnd.getMinutes()
            let secondsEnd = dateJsonEnd.getSeconds()

            dictDataStackedBar['x'] = Date.UTC(year,(month),day,hours,minutes,seconds)
            dictDataStackedBar['x2'] = Date.UTC(yearEnd,(monthEnd),dayEnd,hoursEnd,minutesEnd,secondsEnd)
            dictDataStackedBar['y'] = 0
            if (estado[key]['nombre'] == 'uptime') {
                dictDataStackedBar['color'] = COLORS.UPTIME
                arrayDataUptime.push(dictDataStackedBar)
            } else if (estado[key]['nombre'] == 'downtime') {
                dictDataStackedBar['color'] = COLORS.DOWNTIME
                arrayDataDowntime.push(dictDataStackedBar)
            } else if (estado[key]['nombre'] == 'no monitoreo') {
                dictDataStackedBar['color'] = COLORS.NO_MONITOREO
                arrayDataNoMon.push(dictDataStackedBar)
            } else if (estado[key]['nombre'] == 'downtime parcial') {
                dictDataStackedBar['color'] = COLORS.DOWNTIME_PARCIAL
                arrayDataPartial.push(dictDataStackedBar)
            } else if (estado[key]['nombre'] == 'evento cliente') {
                dictDataStackedBar['color'] = COLORS.EVENTO_CLIENTE
                arrayDataEvent.push(dictDataStackedBar)
            } else if (estado[key]['nombre'] == 'marcado atentus') {
                dictDataStackedBar['color'] = COLORS.MARCADO_ATENTUS
                arrayDataMarcadoAtentus.push(dictDataStackedBar)
            }
        })

        let categoriedNode = []
        Object.keys(Nodo).map((keyNode) => {        
            let estadoNodo = Nodo[keyNode][0]['estado']
            
            if (periodical == true) {
                let lengName = Nodo[keyNode][0]['nodo_nombre']
                if (lengName.length > 13){                    
                    // categoriedNode.push(Nodo[keyNode][0]['nodo_nombre'].substr(0,15) + "...")
                    categoriedNode.push(Nodo[keyNode][0]['nodo_nombre'])
                }else{
                    categoriedNode.push(Nodo[keyNode][0]['nodo_nombre'])
                }
            }else{
                categoriedNode.push(Nodo[keyNode][0]['nodo_nombre'])
            }

            Object.keys(estadoNodo).map((key) => {               
                let dictDataStackedBar = {}
                
                let dateJson = (new Date(estadoNodo[key]['fecha_desde']))
                let year = dateJson.getFullYear()
                let month = dateJson.getMonth()
                let day = dateJson.getDate()
                let hours = dateJson.getHours()
                let minutes = dateJson.getMinutes()
                let seconds = dateJson.getSeconds()

                let dateJsonEnd = (new Date(estadoNodo[key]['fecha_hasta']))
                let yearEnd = dateJsonEnd.getFullYear()
                let monthEnd = dateJsonEnd.getMonth()
                let dayEnd = dateJsonEnd.getDate()
                let hoursEnd = dateJsonEnd.getHours()
                let minutesEnd = dateJsonEnd.getMinutes()
                let secondsEnd = dateJsonEnd.getSeconds()

                dictDataStackedBar['x'] = Date.UTC(year,(month),day,hours,minutes,seconds)
                dictDataStackedBar['x2'] = Date.UTC(yearEnd,(monthEnd),dayEnd,hoursEnd,minutesEnd,secondsEnd)
                dictDataStackedBar['y'] = parseInt(keyNode) 
                if (estadoNodo[key]['nombre'] == 'uptime') {
                    dictDataStackedBar['color'] = COLORS.UPTIME
                    arrayDataUptimeNode.push(dictDataStackedBar)
                } else if (estadoNodo[key]['nombre'] == 'downtime') {
                    dictDataStackedBar['color'] = COLORS.DOWNTIME
                    arrayDataDowntimeNode.push(dictDataStackedBar)
                } else if (estadoNodo[key]['nombre'] == 'no monitoreo') {
                    dictDataStackedBar['color'] = COLORS.NO_MONITOREO
                    arrayDataNoMonNode.push(dictDataStackedBar)
                } else if (estadoNodo[key]['nombre'] == 'downtime parcial') {
                    dictDataStackedBar['color'] = COLORS.DOWNTIME_PARCIAL
                    arrayDataPartialNode.push(dictDataStackedBar)
                }else if (estadoNodo[key]['nombre'] == 'evento cliente') {
                    dictDataStackedBar['color'] = COLORS.EVENTO_CLIENTE
                    arrayEventClient.push(dictDataStackedBar)
                } else if (estadoNodo[key]['nombre'] == 'marcado atentus') {
                    dictDataStackedBar['color'] = COLORS.MARCADO_ATENTUS
                    arrayMarcadoClienteNode.push(dictDataStackedBar)
                }
                
            })
        })
        dictDataStackedBarUptime['data'] = arrayDataUptime
        dictDataStackedBarDowntime['data'] = arrayDataDowntime
        dictDataStackedBarNoMon['data'] = arrayDataNoMon
        dictDataStackedBarPartial['data'] = arrayDataPartial
        dictDataStackedBarEvent['data'] = arrayDataEvent
        dictDataStackedBarMarcadoAtentus['data'] = arrayDataMarcadoAtentus

        dictDataStackedBarUptimeNode['data'] = arrayDataUptimeNode
        dictDataStackedBarDowntimeNode['data'] = arrayDataDowntimeNode
        dictDataStackedBarNoMonNode['data'] = arrayDataNoMonNode
        dictDataStackedBarPartialNode['data'] = arrayDataPartialNode
        dictEventClient['data'] = arrayEventClient
        dictEventMarcadoClienteNode['data'] = arrayMarcadoClienteNode

        let heightNodeChart = 200
        if (Nodo.length < 3) {
            heightNodeChart = 150
        } else if(Nodo.length > 5 && Nodo.length < 10) {
            heightNodeChart = 500
        } else if(Nodo.length > 10) {
            heightNodeChart = 900
        } 

        if (periodical == true) {
            if (Nodo.length < 2 ) {
                heightNodeChart = 150
            }else if(Nodo.length >= 2 && Nodo.length < 4) {
                heightNodeChart = 280    
            }else if(Nodo.length = 5) {
                heightNodeChart = 310    
            } else if(Nodo.length > 5 && Nodo.length < 10) {
                heightNodeChart = 500    
            } else if(Nodo.length > 10) {
                heightNodeChart = 900
            } 
        }

        this.setState({
            chartOptionsStackedBarConsolidated: {
                chart: {
                    type: 'xrange',
                    height: 120,
                },
                title: null,
                credits: {
                    enabled: false
                },                  
                pane: {
                    size: '100%',
                },
                yAxis: { 
                    categories: ['Consolidado'],
                    title: null,
                    gridLineWidth: 0,
                    reversed: true,
                    labels: {
                        useHTML:true,
                        style:{
                            whiteSpace:'normal'
                        },
                        step: 1,
                        formatter: function () {//use formatter
                            return '<div align="left" style="word-wrap: break-word;word-break: break-all;width:150px">' + this.value + '</div>';
                        }
                    },
                },                
                series: [
                        dictDataStackedBarUptime, 
                        dictDataStackedBarDowntime,
                        dictDataStackedBarNoMon, 
                        dictDataStackedBarPartial, 
                        dictDataStackedBarEvent,
                        dictDataStackedBarMarcadoAtentus
                    ],
                plotOptions: {
                    series: {
                        borderRadius: '0px',
                        borderColor: 'transparent',
                        turboThreshold: 30000,
                        boostThreshold: 1,
                        datalabels: false,
                        cursor: 'pointer',
                        point: {
                            events: {
                                mouseOver: this.setHoverDataBar.bind(this),
                                mouseOut: this.showFirstStep,
                                click: this.setClickDataBar.bind(this)
                            }
                        }
                    },
                    xrange: {
                        dataLabels: {
                            enabled: false
                        },
                        borderRadius: 0,
                        grouping: false,
                        borderWidth: 0,
                        pointPadding: 0,
                        borderColor: 'none'
                    },
                },
                legend: {
                    enabled: false
                },
                xAxis: {
                    labels: {
                        enabled: false
                    },
                    visible: false,
                    type: 'datetime',
                    gridLineWidth: 0,
                    dateTimeLabelFormats: {
                        second: '%l:%M:%S%P',
                        minute: '%l:%M%P',
                        hour: '%H:%M',
                        day: '<br/><b>%e/%b</b>',
                        week: '%e. %b',
                        month: '%b %y',
                        year: '%Y'
                    }
                },                
            },
            chartOptionsStackedBarNode: {
                chart: {
                    height: heightNodeChart,
                    type: 'xrange'
                },
                title: null,
                subtitle: null,
                yAxis: {
                    categories: categoriedNode,
                    title: null,
                    gridLineWidth: 0,
                    reversed: true,
                    labels: {
                        useHTML: true,
                        style:{
                            whiteSpace:'normal'
                        },
                        step: 1,
                        formatter: function () {//use formatter
                            return '<div align="left" style="word-wrap: break-word;word-break: break-all;width:150px">' + this.value + '</div>';
                        }
                    },
                },
                plotOptions: {
                    series: {
                        cursor: 'pointer',
                        turboThreshold: 30000,
                        boostThreshold: 1,
                        point: {
                            events: {
                                mouseOver: this.setHoverDataBar.bind(this),
                                mouseOut: this.showFirstStep,
                                click: this.setClickDataBar.bind(this)
                            }
                        }
                    },
                    xrange: {
                        dataLabels: {
                            enabled: false
                        },
                        borderRadius: 0,
                        grouping: false,
                        borderWidth: 0,
                        pointPadding: 0,
                        borderColor: 'none'
                    },
                },
                series: [dictDataStackedBarUptimeNode, dictDataStackedBarDowntimeNode, dictDataStackedBarNoMonNode, dictDataStackedBarPartialNode, dictEventClient, dictEventMarcadoClienteNode],
                legend: {
                    enabled: false
                },
                xAxis: {
                    labels: {
                        enabled: true
                    },
                    visible: true,
                    type: 'datetime',
                    gridLineWidth: 0,
                    dateTimeLabelFormats: {
                        second: '%l:%M:%S%P',
                        minute: '%l:%M%P',
                        hour: '%H:%M',
                        day: '<br/><b>%e/%b</b>',
                        week: '%e. %b',
                        month: '%b %y',
                        year: '%Y'
                    }
                },
                credits: {
                    enabled: false,
                }
            },
            dataError: false,
            isLoading: false,
            lastEvent: lastEventDict,
            time: period,
            monitores: Monitores,
            critic_step: paso_critico,
            chartOptionsBase: {
                ...this.state.chartOptionsBase,
                yAxis: {...this.state.chartOptionsBase.yAxis, categories: categoriedNode},
                series: [dictDataStackedBarUptimeNode, dictDataStackedBarDowntimeNode, dictDataStackedBarNoMonNode, dictDataStackedBarPartialNode, dictEventClient, dictEventMarcadoClienteNode],
                legend: {enabled: false},
                pane: {size: '%100'},
                plotOptions:{
                    series: {
                        turboThreshold: 30000,
                        boostThreshold: 1,
                        stacking: ""
                        },
                    xrange: {
                        dataLabels: {
                            enabled: false
                        },
                        borderRadius: 0,
                        grouping: false,
                        borderWidth: 0,
                        pointPadding: 0,
                        borderColor: 'none'
                    },
                }
            }
        }, this.showFirstStep);

    }
    render() {
        const { classes, t } = this.props;
        const { loadError, chartOptionsStackedBarConsolidated, chartOptionsStackedBarNode, isLoading, 
            modalOpen, currentObjectiveId, point, monitores,chartOptionsBase, critic_step} = this.state;
        if (isLoading) {
            return (
                <PortletContent>
                    <PerfectScrollbar>
                        <Typography
                        variant="h5"
                        >
                        <CircularProgress
                        variant="indeterminate"
                        size={24}
                        thickness={4}
                        />
                        <br/>
                            {t('text.loading')}
                        </Typography>
                    </PerfectScrollbar>
                </PortletContent>
            )
        }
        if (!isLoading && chartOptionsStackedBarConsolidated?.yAxis?.categories?.length > 0 && chartOptionsStackedBarNode?.yAxis?.categories?.length > 0) {
            sessionStorage.setItem("chartAvailabilityConsolidated",JSON.stringify(chartOptionsBase))
            sessionStorage.setItem("ConsolidatedCategorie",JSON.stringify(chartOptionsStackedBarConsolidated.yAxis.categories))
            sessionStorage.setItem("ConsolidatedSeries",JSON.stringify(chartOptionsStackedBarConsolidated.series))
            // sessionStorage.setItem("chartOptionsStackedBarConsolidated",JSON.stringify(chartOptionsStackedBarConsolidated))
            return (<FormattedChart chartOptionsStackedBarConsolidated={chartOptionsStackedBarConsolidated} 
                                    chartOptionsStackedBarNode={chartOptionsStackedBarNode}
                                    modalOpen={modalOpen} modalClose={this.setCloseModal} 
                                    classes={classes} objective={currentObjectiveId}
                                    point={point}
                                    monitores={monitores}
                                    critic_step={critic_step}/>
                                    )
        }
        let noData = false
        sessionStorage.setItem("chartAvailabilityConsolidated",noData)
        if (loadError) {
            return (
                <Box textAlign="center">
                    <Typography>{t('text.load-error')}</Typography>
                    <Button color="primary" onClick={this.handleRetry}>{t('text.retry')}</Button>
                </Box>
            )
        }
        return (<p>{t('text.no-data')}</p>)

    }
}

function FormattedChart(props) {
    sessionStorage.setItem("chartOptionsStackedBarConsolidated",JSON.stringify(props.chartOptionsStackedBarConsolidated))
    return (
        <div>
                <PerfectScrollbar>
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={props.chartOptionsStackedBarConsolidated} />
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={props.chartOptionsStackedBarNode} />
                </PerfectScrollbar>
            <Dialog
                maxWidth='xl'
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={props.modalOpen}
                onClose={props.modalClose}
                disableAutoFocus={true}
                disableEnforceFocus={true}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 100,
                }}               
            >
                <Fade in={props.modalOpen}>
                    <EventsTable objective={props.objective} dates={props.point} monitores={props.monitores} onClose={props.modalClose} critic_step={props.critic_step}/>
                </Fade>
            </Dialog>
        </div>
    )
}

export default compose(withRouter, withStyles(styles), withTranslation())(AvailabilityConsolidated);